import { Injectable, Inject } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class ScriptLoaderService {
    private scripts = {};

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private logger: LoggerService,
    ) {}

    loadScript(src: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            if (!src) {
                this.logger.error(`Must provide script source!`);
                return resolve(false);
            }

            if (this.scripts[src]) {
                this.logger.log(`Script ${src} already loaded.`);
                return resolve(false);
            }

            this.scripts[src] = false;

            const htmlHeadElement = this.document.head;
            const script = this.createScriptElement(src);

            script.onerror = (err) => {
                this.logger.error(`Script error: ${err}`);
                return resolve(false);
            };
            script.onload = () => {
                this.logger.debug(`Script ${src} loaded.`);
                this.scripts[src] = true;
                return resolve(true);
            };

            htmlHeadElement.appendChild(script);
        });
    }

    private createScriptElement(src: string): HTMLScriptElement {
        const script: HTMLScriptElement = this.document.createElement('script');

        script.type = 'text/javascript';
        script.src = src;
        script.async = true;
        script.defer = true;

        return script;
    }
}
